import React from "react";
import { Serie } from "../types/Serie";

import "../css/cover.css";

type Props = {
  serie: Serie;
  onClickCover?: () => void;
  style?: React.CSSProperties | undefined;
  badge?: string;
};

const DefaultCoverV2 = (props: Props) => {
  const { onClickCover, serie, style, badge } = props;
  const isClickable = !!onClickCover;

  return (
    <div
      className={`nbk-cover${isClickable ? " nbk-cover--clickable" : ""}${badge ? " nbk-cover--highlighted" : ""}`}
      style={{
        minWidth: 165,
        maxWidth: 165,
        aspectRatio: 165 / 219,
        borderRadius: 8,
        overflow: "hidden",
        marginLeft: 5,
        marginRight: 5,
        marginTop: 10,
        cursor: isClickable ? "pointer" : "default",
        ...style,
      }}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      aria-label={isClickable && serie.name ? `Ouvrir la série ${serie.name}` : undefined}
      onClick={() => {
        if (onClickCover) onClickCover();
      }}
      onKeyDown={(e) => {
        if (onClickCover && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClickCover();
        }
      }}
    >
      <img
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          backgroundColor: "#C3C3C3",
        }}
        src={`https://newbrand.s3.eu-west-3.amazonaws.com/series/${serie.uid}/couvertures/${serie.img}`}
        alt={serie.name || ""}
        loading="lazy"
        draggable={false}
      />
      {badge ? <span className="nbk-cover__badge">{badge}</span> : null}
    </div>
  );
};

export default DefaultCoverV2;
